import { render, staticRenderFns } from "./idMobile.vue?vue&type=template&id=3d5f90b8&scoped=true&"
import script from "./idMobile.vue?vue&type=script&lang=js&"
export * from "./idMobile.vue?vue&type=script&lang=js&"
import style0 from "./idMobile.vue?vue&type=style&index=0&id=3d5f90b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f90b8",
  null
  
)

export default component.exports